<button mat-button (click)="toggleFlyout()" class="sales-tax-invoice-params-opener">
	<i class="fa fa-file fa-lg grayImage" aria-hidden="true"></i>
	<span>Sales Tax Due</span>
</button>
<ng-template cdk-portal>
	<div class="linq-drawer-content">
		<header class="linq-drawer-header">
			<h3 class="linq-heading">Generate Sales Tax Due Invoice</h3>
			<button class="linq-drawer-header__close linq-button-close-lg" (click)="close()">
				<mat-icon>clear</mat-icon>
			</button>
		</header>
		<div class="sales-tax-due-params-wrapper linq-drawer-inner-content flyout-inner-container linq-drawer-inner-content--spaced">
			<form (ngSubmit)="salesTaxInvoiceParamsForm.valid && submitSalesTaxInvoiceParams()" #salesTaxInvoiceParamsForm="ngForm" *ngIf="!readOnly"
				validators>

				<mat-form-field [ngStyle]="{ width: dateRangeWidth }">
					<mat-label>Date range</mat-label>
					<mat-date-range-input [rangePicker]="invoiceDatePicker">
						<input matStartDate name="invoiceDateFrom" #invoiceDateFrom="ngModel" [(ngModel)]="dateFrom" placeholder="From"
							(dateChange)="onDatesChange()">
						<input matEndDate name="invoiceDateTo" #invoiceDateTo="ngModel" [(ngModel)]="dateTo" placeholder="To"
							(dateChange)="onDatesChange()">
					</mat-date-range-input>
					<mat-datepicker-toggle matSuffix [for]="invoiceDatePicker"></mat-datepicker-toggle>
					<mat-date-range-picker #invoiceDatePicker panelClass="linq-date-picker"></mat-date-range-picker>
				</mat-form-field>

				<div *ngIf="datesErrorMessage">
					<mat-label class="error">{{datesErrorMessage}}</mat-label>
				</div>

				<div *ngIf="this.isDataLoaded" class="sales-info">
					<h4 class="linq-heading">Invoice Details</h4>
					<div *ngIf="!info.InvoicesWithDiscrepancy">
						There are no invoices with discrepancies in the specified period.
					</div>
					<div *ngIf="info.InvoicesWithDiscrepancy">
						<div class="row sales-info-row">
							<div class="col-xs-6">
								<mat-label>Total Sales Tax Due:</mat-label>
							</div>
							<div class="col-xs-5 text-right">
								<mat-label class="value">${{ info.TotalTaxDue }}</mat-label>
							</div>
						</div>
						<div class="row sales-info-row">
							<div class="col-xs-6">
								<mat-label>Invoices with Discrepancy:</mat-label>
							</div>
							<div class="col-xs-5 text-right">
								<mat-label class="value">{{ info.InvoicesWithDiscrepancy }}</mat-label>
							</div>
						</div>
						<div class="row sales-info-row">
							<div class="col-xs-6">
								<mat-label>Affected Accounts:</mat-label>
							</div>
							<div class="col-xs-5 text-right">
								<mat-label class="value">{{ info.EffectedAccounts }}</mat-label>
							</div>
						</div>

						<div class="control">
							<button type="submit" mat-raised-button color="primary" class="pull-right" [disabled]="!isDataLoaded">Generate</button>
						</div>
					</div>
				</div>
				<div class="clearfix"></div>
			</form>
		</div>
	</div>
</ng-template>